package com.evoapps.evoshift.data.dto.tips

import kotlinx.serialization.Serializable

/**
 * workplaces/{wpId}/tip_pools/{start}_{end} (SH-124), written only by functions/tips.js; also
 * what saveTipPool returns.
 */
@Serializable
data class TipPoolDto(
    val id: String = "",
    val workplaceId: String = "",
    val period: String = "DAY",
    val startDate: String = "",
    val endDate: String = "",
    val amountMinor: Long = 0,
    val currency: String = "PLN",
    val roleWeights: Map<String, Int> = emptyMap(),
    val shares: List<TipShareDto> = emptyList(),
    val updatedAt: String? = null,
    val updatedBy: String? = null,
    val source: String? = null
)

@Serializable
data class TipShareDto(
    val userId: String = "",
    val displayName: String = "",
    val role: String? = null,
    val minutesWorked: Long = 0,
    val amountMinor: Long = 0
)

/** workplaces/{wpId}/tip_shares/{poolId}_{userId}: one person's own share. */
@Serializable
data class MyTipShareDto(
    val poolId: String = "",
    val workplaceId: String = "",
    val userId: String = "",
    val period: String = "DAY",
    val startDate: String = "",
    val endDate: String = "",
    val amountMinor: Long = 0,
    val currency: String = "PLN",
    val minutesWorked: Long = 0
)

/** What kioskTipPool returns: the day's pool for the tablet (amountMinor null: none yet). */
@Serializable
data class KioskTipPoolDto(
    val date: String = "",
    val amountMinor: Long? = null,
    val currency: String = "PLN",
    val shares: List<TipShareDto> = emptyList()
)
